import { Box, Icon } from '@rbilabs/universal-components';
import { StatusBar } from 'expo-status-bar';
import { Typography } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';
import { WEB_APP_MAX_WIDTH_DESKTOP_LARGE } from 'utils/constants';

export const NoNetworkHeader = () => {
  return (
    <>
      <StatusBar backgroundColor={NO_NETWORK_BACKGROUND_COLOR} />
      <Box alignItems="center" backgroundColor={NO_NETWORK_BACKGROUND_COLOR}>
        <Box
          flexDirection="row"
          alignItems="center"
          maxWidth={WEB_APP_MAX_WIDTH_DESKTOP_LARGE}
          width="100%"
          marginLeft={{ base: 10, md: 0 }}
        >
          <Icon variant="warning" width="14px" marginRight={1} />
          <Typography variant="copyTwo" style={{ lineHeight: 14 }}>
            {t('noInternetConnection')}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export const NO_NETWORK_BACKGROUND_COLOR = '#FBE8E7';
